import {SYS} from '@/config'
import store from '../store'

import salesRoutes from './module/sales.js';  				// 销售模块
import purchaseRoutes from './module/purchase.js';		// 采购管理
import productionRoutes from './module/production.js';  	// 生产模块
import qualityRoutes from './module/quality.js';  			// 质量模块
import customRoutes from './module/custom';				// 自定义配置模块
import basicRoutes from './module/basic.js';				// 基础管理
import systemRoutes from './module/system.js';				// 系统管理
import storageRoutes from './module/storage.js';			// 库存管理
import reportRoutes from './module/report.js';				// 报表
import supplyRoutes from './module/supply.js';			// 上下游管理
import kanbanRoutes from './module/kanban.js';			// 数据看板
import toolRoutes from './module/tool.js';			// 快捷工具
import collabRoutes from './module/collab.js';			// 任务协同

const routes = [
	{
		path: '',
		name: 'home',
		meta: {
			authFree: true
		},
		component: () => import('@/pages/home/index')
	}, {
		path: 'upgrade',
		meta: {
			title: '版本对比',
			authFree: true
		},
		component: () => import('@/pages/home/upgrade')
	}, {
		path: 'video',
		meta: {
			title: '视频教程',
			authFree: true
		},
		component: () => import('@/pages/home/video')
	}, {
		path: 'sales',
		name: 'p_sales',
		component: {
			render: h => h('router-view')
		},
		children: [
			...salesRoutes
		]
	}, {
		path: 'purchase',
		name: 'p_purchase',
		component: {
			render: h => h('router-view')
		},
		children: [
			...purchaseRoutes
		]
	}, {
		path: 'production',
		name: 'p_production',
		component: {
			render: h => h('router-view')
		},
		children: [
			...productionRoutes
		]
	}, {
		path: 'quality',
		name: 'p_quality',
		component: {
			render: h => h('router-view')
		},
		children: [
			...qualityRoutes
		]
	}, {
		path: 'custom',
		name: 'p_custom',
		component: {
			render: h => h('router-view')
		},
		children: [
			...customRoutes
		]
	}, {
		path: 'basic',
		name: 'p_basic',
		component: {
			render: h => h('router-view')
		},
		children: [
			...basicRoutes
		]
	}, {
		path: 'system',
		name: 'p_organization',
		component: {
			render: h => h('router-view')
		},
		children: [
			...systemRoutes
		]
	}, {
		path: 'storage',
		name: 'p_storage',
		component: {
			render: h => h('router-view')
		},
		children: [
			...storageRoutes
		]
	}, {
		path: 'report',
		name: 'p_report',
		component: {
			render: h => h('router-view')
		},
		children: [
			...reportRoutes
		]
	}, {
		path: 'supply',
		name: 'p_supply_chain',
		component: {
			render: h => h('router-view')
		},
		children: [
			...supplyRoutes
		]
	}, {
		path: 'kanban',
		name: 'p_workshop',
		component: {
			render: h => h('router-view')
		},
		children: [
			...kanbanRoutes
		]
	}, {
		path: 'collab',
		name: 'p_collab',
		component: {
			render: h => h('router-view')
		},
		children: [
			...collabRoutes
		]
	}, {
		path: 'tool',
		name: 'g_tool',
		component: {
			render: h => h('router-view')
		},
		children: [
			...toolRoutes
		]
	}
];

export default [{
	path: '/login',
	name: 'login',
	meta: {
		loginFree: true
	},
	props: route => route.query,
	component: () => SYS == 'digital' ? import('@/pages/login/digital') : import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/register',
	name: 'register',
	meta: {
		loginFree: true
	},
	component: () => import('@/pages/login/register'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: routes,
	beforeEnter: async (to, from, next) => {
		if (SYS == 'digital') {
			next('/digital');
		} else {
			next();
		}
	}
}, {
	path: '/window',
	props: {
		windowPage: true
	},
	component: () => import('@/pages/index'),
	children: routes,
	beforeEnter: async (to, from, next) => {
		if (SYS == 'digital') {
			next('/digital');
		} else {
			next();
		}
	}
}, {
	path: '/digital',
	component: () => import('@/pages/kanban/digital'),
	beforeEnter: async (to, from, next) => {
		if (SYS == 'digital') {
			next();
		} else {
			next('/');
		}
	}
}, {
	path: '/digital/:id',
	props: route => route.params,
	component: () => import('@/pages/kanban/digital')
}, {
	path: '/print',
	component: () => import('@/pages/home/print')
}, {
	path: '/doc',
	props: route => route.query,
	component: () => import('@/pages/home/doc')
}, {
	path: '/file_view',
	props: route => route.query,
	component: () => import('@/pages/home/file_view')
}, {
	path: '/comp',
	meta: {
		loginFree: true
	},
	component: () => import('@/pages/api/index')
}, {
	path: '*',
	redirect: '/'
}];